import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAuthState } from "@web-src/modules/auth/store/authSlice";
import PropTypes from "prop-types";
import { Navigate, useSearchParams } from "react-router-dom";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";

function PublicRoute({ component }) {
  const { isAuthenticated } = useSelector(selectAuthState);
  const [loading, setLoading] = useState(true);
  const { generateUrl } = useNavigation();
  const [searchParams] = useSearchParams();
  const linkToOpenAfterLogin = searchParams.get("next");

  useEffect(() => {
    if (isAuthenticated) {
      setLoading(false);
    }
  }, [isAuthenticated]);

  if (!loading && isAuthenticated) {
    return (
      <Navigate
        to={{
          pathname: generateUrl("entryPoint"),
          search: linkToOpenAfterLogin
            ? `?next=${encodeURIComponent(linkToOpenAfterLogin)}`
            : "",
        }}
      />
    );
  }

  return isAuthenticated ? null : component;
}

PublicRoute.propTypes = {
  component: PropTypes.node,
};

export default PublicRoute;
